"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPinByCookie = exports.setCookie = exports.getCookie = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
function getCookie(name) {
    return js_cookie_1.default.get(name);
}
exports.getCookie = getCookie;
function setCookie(name, value, options) {
    js_cookie_1.default.set(name, value, options);
}
exports.setCookie = setCookie;
var getPinByCookie = function () {
    return getCookie("pt_pin") || getCookie("pin") || getCookie("pwdt_id");
};
exports.getPinByCookie = getPinByCookie;
